import React from 'react';
import PropTypes from 'prop-types';
// imgs
import emptyList from 'assets/icons/empty_list.png';
import emptyPage from 'assets/icons/nosearch.svg';
// styles
import styles from './EmptyPage.module.scss';

const EmptyList = ({ emptyMessage, type }) => {
  const useClass = type === 'report' ? styles.emptyPage : styles.emptyList;
  const useIcon = type === 'report' ? emptyPage : emptyList;

  return (
    <div className={useClass}>
      <img src={useIcon} alt={emptyMessage} />
      <div>{emptyMessage}</div>
    </div>
  );
};

EmptyList.defaultProps = {
  emptyMessage: 'Não há elementos a serem exibidos',
  type: 'list'
};

EmptyList.propTypes = {
  emptyMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  type: PropTypes.oneOf(['list', 'report'])
};

export default EmptyList;
